import { useContext } from 'react';
import { AccountSettingsContext, AccountSettingsContextData } from './context';

export function useAccountSettings(): AccountSettingsContextData {
    const data = useContext<AccountSettingsContextData | undefined>(
        AccountSettingsContext
    );

    if (!data) {
        throw new Error(
            "AccountSettingsContextData unavailable. Are you sure you're using this in a nested component of an AccountSettingsProvider?"
        );
    }

    return data;
}
